var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationSubway = function SvgGeneralInformationSubway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.375 18.75A1.877 1.877 0 0 1 4.5 16.875v-4.508h15v6.383zM4.5 11.617h15V5.25h-15zM6.375 4.5h11.25V2.25H6.375zm13.875 0h-1.875v-3H5.625v3H3.75v12.375A2.63 2.63 0 0 0 6.375 19.5h.969l-2.36 2.36.532.53 2.89-2.89h7.564l2.89 2.89.53-.53-2.359-2.36h3.219z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 16.28a.75.75 0 1 1 .002-1.502.75.75 0 0 1-.002 1.502m0-2.25a1.5 1.5 0 1 0 .001 3 1.5 1.5 0 0 0-.001-3M15.75 16.28a.75.75 0 1 1 .002-1.502.75.75 0 0 1-.002 1.502m0-2.25a1.5 1.5 0 1 0 .001 3 1.5 1.5 0 0 0-.001-3"
  }))));
};
export default SvgGeneralInformationSubway;